import { User } from "./user.model";

export interface Approval {
    id: number,
    admin?: User
    // All approvers across the approval chain, joined by ", " - only populated for the
    // Download Records tab (see GetApprovalsForRecords on the backend).
    approverNames?: string
    questionnarieName: string,
    user: User,
    createDate: Date,
    updateDate: Date,
    status: EApprovalStatus,
    recipientGuid: string,
    recipientId?: number,
    requiredAmount?: number;
    approvedAmount?: number;
    expenseRowsCount?: number;
    comment?: string;
    groupName?: string;
    // "חודש שכר" (After Approval tab): every payroll month (yyyyMM, ascending) the request was
    // exported to payroll in; empty = not transferred yet. payrollExportCount counts the exports
    // themselves - above 1 is a suspected double payment, even when it's all the same month.
    payrollMonths?: number[];
    payrollExportCount?: number;
}

export enum EApprovalStatus {
    PendingApproval = 1, Rejected, Approved, PendingPrevApproval
}

export interface StatusFlowDto {
    date: string | null;
    status: EApprovalStatus | null;
    name: string | null;
    isEnd: boolean
}

export enum EnumRecordsTypes {
    ApproverManager = 1,
    PayrollRepresentative = 2,
    AccountingRepresentative = 3,
    DetailedAccountingRepresentative = 4,
    Billing = 5
}

export enum EnumApprovalsTabs
{
    PendingApproval = 1,
    AfterApproval,
    DownloadRecords,
    Reports
}

export enum ApprovalSortBy {
  SentDate = 'sentDate',
  SenderName = 'senderName',
  ApproverName = 'approverName',
  ApprovalDate = 'approvalDate',
  ExtraDetails = 'extraDetails',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface ApprovalSort {
  sortBy: ApprovalSortBy;
  sortDirection: SortDirection;
}